import React from "react";
import CustomTabs from "components/Shared/CustomTabs";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import NoteTab from "../../Note/Notetab";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import { useTripDetailContext } from "contexts/TripDetailContext";
import TripLoadingTab from "./TripLoadingTab";

const TripDetailTab = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "notes";

  const { tripDetail } = useTripDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: "Trip",
      sourceRef: tripDetail?._id,
    },
    { skip: !tripDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "Trip", sourceRef: tripDetail?._id },
    { skip: !tripDetail?._id }
  );

  const tabs = [
    {
      label: "Notes",
      value: "notes",
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
    { label: "Trip Loading", value: "trip-loading", badgeCount: 0 }, // New tab added
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {tripDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="notes">
            <NoteTab
              source="Trip"
              sourceRef={tripDetail._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="Trip"
              sourceRef={tripDetail._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="trip-loading">
            <TripLoadingTab
            />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default TripDetailTab;